import { z } from "zod/v3";
import { ZodOutputFor, createSchema } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { RetShift, retShiftSchema } from "../models/retShift";
import { RetShiftResponse as ProtoRetShiftsResponse } from "@opstel/gen/knop/ui/v1/api/retshifts_pb";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface RetShifts {
  status: ResponseStatus;
  retShifts: RetShift[];
}

const RetShiftsResponseSchema = createSchema<RetShifts, PlainMessage<ProtoRetShiftsResponse>>({
  retShifts: z.array(retShiftSchema),
  message: z.string(),
  status: responseStatusSchema,
}) as ZodOutputFor<RetShifts>;

export function parseRetShiftsData(proto: PlainMessage<ProtoRetShiftsResponse>): RetShifts {
  return RetShiftsResponseSchema.parse(proto);
}
